import React from 'react'
// @ts-ignore
import { Bubble } from '@netbasequid/chart'
import { useDisplayTheme } from 'hooks/useUiState'

type BubbleChartProps = {
  data: any
  xAxisTitle: string
  yAxisTitle: string
  zAxisTitle: string
  insufficientThreshold: number
  lowDataThreshold: number
  lowDataTooltipTitlePostfix: string
  lowDataTooltipDescription: string
  quadrantLabels: string[]
  xAxisLabelFormatter: ({ value }: { value: number }) => number | string
  yAxisLabelFormatter: ({ value }: { value: number }) => number | string
  minSize: string
  maxSize: string
}

const BubbleChart = ({
  data,
  xAxisTitle,
  yAxisTitle,
  zAxisTitle,
  insufficientThreshold,
  lowDataThreshold,
  lowDataTooltipTitlePostfix,
  lowDataTooltipDescription,
  quadrantLabels,
  xAxisLabelFormatter,
  yAxisLabelFormatter,
  minSize,
  maxSize
}: BubbleChartProps) => {
  const theme = useDisplayTheme()

  return (
    <Bubble
      mode={theme}
      data={data}
      xAxisTitle={xAxisTitle}
      yAxisTitle={yAxisTitle}
      zAxisTitle={zAxisTitle}
      insufficientThreshold={insufficientThreshold}
      lowDataThreshold={lowDataThreshold}
      lowDataTooltipTitlePostfix={lowDataTooltipTitlePostfix}
      lowDataTooltipDescription={lowDataTooltipDescription}
      quadrantLabels={quadrantLabels}
      xAxisLabelFormatter={xAxisLabelFormatter}
      yAxisLabelFormatter={yAxisLabelFormatter}
      minSize={minSize}
      maxSize={maxSize}
    />
  )
}

export default BubbleChart

export * from './types'
